import {createSelector} from 'reselect';

const selectUsageStatistic = (state) => state.usageStatistic;

const selectUsageStats = createSelector(selectUsageStatistic, (state) => state.usageStats);

const selectIsUsageStatsExists = createSelector(selectUsageStatistic, (state) => {
    const usageStats = state.usageStats;

    if (!usageStats?.length) return false;

    return !!usageStats.find((item) => !!item?.leviaDayRecords?.length || !!item?.dayRecords?.length);
});

const selectAssetsIdList = createSelector(selectUsageStatistic, (state) => state.assetIdList);

const selectExperienceDataRanges = createSelector(selectUsageStatistic, (state) => state.experienceDataRanges);

const selectUsageActiveTab = createSelector(selectUsageStatistic, (state) => state.usageActiveTab);

const selectUsageIs12HoursMode = createSelector(selectUsageStatistic, (state) => state.usageIs12HoursMode);

const selectIsAnyLeviaUsageStats = createSelector(selectUsageStatistic, (state) => {
    const usageStatsDetails = state.usageStatsDetails;

    if (!usageStatsDetails?.length) return false;

    let totalCount = 0;

    usageStatsDetails.forEach((x) =>
        x?.leviaDayRecords?.forEach((dayRecord) =>
            dayRecord?.records?.forEach((record) => (totalCount += record.count))
        )
    );

    return totalCount > 0;
});

export {
    selectAssetsIdList,
    selectExperienceDataRanges,
    selectIsAnyLeviaUsageStats,
    selectIsUsageStatsExists,
    selectUsageActiveTab,
    selectUsageIs12HoursMode,
    selectUsageStats,
};
